import React from 'react';
import { SpeakerHero } from '../components/SpeakerHero';
import { EventIntro } from '../components/EventIntro';
import { RegistrationForm } from '../components/RegistrationForm';
import { SiteFooter } from '../components/SiteFooter';
export function AgentScalingWorkshop() {
  return <div className="relative min-h-full w-full overflow-x-hidden bg-ink-950 text-white" data-id="element-54" data-mp="2w290hi4ah9dh">
      {/* Architectural purple texture: faint diagonals plus stronger edge accents,
          drawn in a single composited layer to keep painting cheap */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-0" style={{
      backgroundImage: 'repeating-linear-gradient(115deg, rgba(139,92,246,0.10) 0 1px, transparent 1px 140px), repeating-linear-gradient(-115deg, rgba(255,255,255,0.028) 0 1px, transparent 1px 190px), linear-gradient(115deg, rgba(168,85,247,0.28) 0 2px, transparent 2px 100%), linear-gradient(-115deg, rgba(168,85,247,0.28) 0 2px, transparent 2px 100%)',
      backgroundPosition: 'left top, left top, left top, right top',
      backgroundRepeat: 'repeat, repeat, no-repeat, no-repeat',
      backgroundSize: 'auto, auto, 26% 100%, 26% 100%',
      willChange: 'auto',
      transform: 'translateZ(0)'
    }} data-id="element-55" data-mp="23ed5chudbpit" />

      <main className="relative" data-id="element-56" data-mp="2652u8ehglalj">
        <SpeakerHero data-id="element-57" data-mp="263roi94gdsrs" />

        <div className="mt-6 sm:mt-24" data-id="element-58" data-mp="262gn2fyhcx3u">
          <EventIntro data-id="element-59" data-mp="215ggm3xpxsc7" />
        </div>

        <div className="mt-7 sm:mt-24" data-id="element-60" data-mp="216hs29incgug">
          <RegistrationForm data-id="element-61" data-mp="1w6d8ubqct80j" />
        </div>

        <SiteFooter data-id="element-62" data-mp="1w5bv1zhye7f4" />
      </main>
    </div>;
}